function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Ref, FC, useState, useEffect, ReactNode, useCallback, CSSProperties, RefObject } from 'react';
import cn from 'classnames';
import defaultImage from './Image.assets/no-photo.png';
require("./Image.css");
var styles = {
  "Root": "Image-module-Root_2dZ",
  "Control": "Image-module-Control_370",
  "loaded": "Image-module-loaded_k4J",
  "animated": "Image-module-animated_yhe",
  "fadeIn": "Image-module-fadeIn_3Me"
};
export const Image = ({
  className,
  alt = 'изображение товара',
  src = {
    defaultImage
  },
  srcSet,
  loading = 'lazy',
  fallbackSrc,
  stub,
  innerRef,
  controlRef,
  width,
  height,
  sizes,
  style = {},
  ...props
}) => {
  const [animation, setAnimation] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const [shouldRemoveStub, setShouldRemoveStub] = useState(false);
  const isStub = Boolean(stub);
  const imgClasses = cn(styles.Root, {
    [styles.animated]: animation && isStub,
    [styles.loaded]: isLoaded
  }, className);
  const handleError = useCallback(() => {
    setIsFailed(true);
  }, []);
  const handleLoad = useCallback(() => {
    setIsLoaded(true);
  }, []);
  const handleRemoveStub = useCallback(() => {
    setShouldRemoveStub(true);
  }, []);
  const source = isFailed ? fallbackSrc || defaultImage : src;
  const image = /*#__PURE__*/React.createElement("img", {
    className: imgClasses,
    alt: alt,
    src: source,
    srcSet: srcSet,
    sizes: sizes,
    style: {
      width,
      height,
      ...style
    },
    loading: loading,
    ref: controlRef,
    onError: handleError,
    onLoad: handleLoad,
    onAnimationEnd: handleRemoveStub
  });
  useEffect(() => {
    const timer = setTimeout(() => {
      if (isLoaded) {
        setAnimation(true);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [isLoaded, setAnimation]);
  if (stub) {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: styles.Control,
      ref: innerRef
    }, props), isLoaded && !shouldRemoveStub && stub, image);
  }
  return image;
};
if (process.env.NODE_ENV !== 'production') {
  Image.displayName = 'Image';
}